(() => {
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';

    const section = document.getElementById(("YurchakHero-" + __shopifySectionId + ""));

    if (!section || section.dataset.yhInitialized === 'true') return;

    section.dataset.yhInitialized = 'true';

    const ticker = section.querySelector('[data-yh-ticker]');
    const track = section.querySelector('[data-yh-ticker-track]');

    let previousTime = null;
    let paused = false;
    let resumeTimer = null;
    let animationFrame = null;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const isMobile = () => mobileQuery.matches;

    const syncHeroVideo = () => {
      const desktopVideo = section.querySelector('.yurchak-hero__video--desktop');
      const mobileVideo = section.querySelector('.yurchak-hero__video--mobile');
      const activeVideo = isMobile() ? mobileVideo : desktopVideo;
      const inactiveVideo = isMobile() ? desktopVideo : mobileVideo;

      if (inactiveVideo) {
        inactiveVideo.pause();
        inactiveVideo.preload = 'none';
        inactiveVideo.setAttribute('preload','none');
      }

      if (activeVideo) {
        activeVideo.preload = 'auto';
        activeVideo.setAttribute('preload','auto');
        activeVideo.muted = true;
        activeVideo.defaultMuted = true;
        activeVideo.playsInline = true;
        const attemptPlay = () => {
          const playPromise = activeVideo.play();
          playPromise?.catch?.(() => {});
        };
        if (activeVideo.readyState < 2) {
          activeVideo.addEventListener('canplay', attemptPlay, { once: true });
          try { activeVideo.load(); } catch (_) {}
        } else {
          attemptPlay();
        }
      }
    };

    const updateHeaderHeight = () => {
      const header =
        document.querySelector('#shopify-section-header .header-wrapper') ||
        document.querySelector('#shopify-section-header') ||
        document.querySelector('header');

      const height = header
        ? Math.round(header.getBoundingClientRect().height)
        : 0;

      section.style.setProperty('--yh-header-height', `${height}px`);
    };

    const stopTicker = () => {
      paused = true;
      previousTime = null;

      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    };

    const resumeTicker = () => {
      const delay = Number(ticker?.dataset.resumeDelay || 1200);

      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
      }

      resumeTimer = window.setTimeout(() => {
        paused = false;
        previousTime = null;
      }, delay);
    };

    const animateTicker = (time) => {
      if (!ticker || !track || !isMobile() || document.hidden) {
        previousTime = null;
        animationFrame = null;
        return;
      }

      if (!paused) {
        if (previousTime !== null) {
          const delta = time - previousTime;
          const speed = Number(ticker.dataset.mobileSpeed || 55);
          ticker.scrollLeft += (speed * delta) / 1000;

          const halfWidth = track.scrollWidth / 2;
          if (halfWidth > 0 && ticker.scrollLeft >= halfWidth) ticker.scrollLeft -= halfWidth;
          if (halfWidth > 0 && ticker.scrollLeft < 0) ticker.scrollLeft += halfWidth;
        }
        previousTime = time;
      } else {
        previousTime = null;
      }

      animationFrame = window.requestAnimationFrame(animateTicker);
    };

    const syncTickerAnimation = () => {
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
      previousTime = null;

      if (reduceMotionQuery.matches) return;

      if (ticker && track && isMobile() && !document.hidden) {
        animationFrame = window.requestAnimationFrame(animateTicker);
      }
    };

    if (ticker) {
      ticker.addEventListener('pointerdown', stopTicker);
      ticker.addEventListener('pointerup', resumeTicker);
      ticker.addEventListener('pointercancel', resumeTicker);
      ticker.addEventListener('pointerleave', resumeTicker);

      ticker.addEventListener(
        'touchstart',
        stopTicker,
        { passive: true }
      );

      ticker.addEventListener(
        'touchend',
        resumeTicker,
        { passive: true }
      );

      ticker.addEventListener(
        'wheel',
        () => {
          stopTicker();
          resumeTicker();
        },
        { passive: true }
      );
    }

    updateHeaderHeight();
    syncHeroVideo();
    syncTickerAnimation();

    window.addEventListener(
      'resize',
      updateHeaderHeight,
      { passive: true }
    );

    const handleResponsiveChange = () => {
      syncHeroVideo();
      syncTickerAnimation();
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleResponsiveChange);
      reduceMotionQuery.addEventListener('change', handleResponsiveChange);
    } else {
      mobileQuery.addListener(handleResponsiveChange);
      reduceMotionQuery.addListener(handleResponsiveChange);
    }

    document.addEventListener('visibilitychange', () => {
      syncHeroVideo();
      syncTickerAnimation();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target || !event.target.contains(section)) return;

      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
      }

      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
      }
    });
  })();
